export default __webpack_public_path__ + "static/media/logo-header.3af88c33.svg";